import React from "react";
import "./../../../../../assets/css/Dashboard/ServicesCalendar.scss";
import CustomScheduler from "./Calender/CustomScheduler";
import CustomPlanner from "../../../../../components/CustomPlanner/CustomPlanner";
import { IoMdFunnel } from "react-icons/io";
import CalendarIcon from "./../../../../../assets/images/calendar.svg";

export default function ServicesCalendar() {
  return (
    <div className="services_content-bg services_calendar">
      <CustomScheduler />
    </div>
  );
}

